export const ATTENDANCE_WORK_SHIFT_PERMISSION_CODES = {
    WEB_ATTENDANCE_WORK_SHIFT_LIST: 'WEB_ATTENDANCE_WORK_SHIFT_LIST',
    WEB_ATTENDANCE_WORK_SHIFT_DETAIL: 'WEB_ATTENDANCE_WORK_SHIFT_DETAIL',
    WEB_ATTENDANCE_WORK_SHIFT_ADD: 'WEB_ATTENDANCE_WORK_SHIFT_ADD',
    WEB_ATTENDANCE_WORK_SHIFT_EDIT: 'WEB_ATTENDANCE_WORK_SHIFT_EDIT',
    WEB_ATTENDANCE_WORK_SHIFT_DELETE: 'WEB_ATTENDANCE_WORK_SHIFT_DELETE',
    WEB_ATTENDANCE_WORK_SHIFT_IMPORT: 'WEB_ATTENDANCE_WORK_SHIFT_IMPORT',
    WEB_ATTENDANCE_WORK_SHIFT_EXPORT: 'WEB_ATTENDANCE_WORK_SHIFT_EXPORT',
} as const;

